export const CARD_LIST_ITEM_IMAGE = {
  REFERRAL: 'card-list-item-referral',
  PROVIDER: 'card-list-item-provider',
  PHARMACY: 'card-list-item-pharmacy',
  EMPTY: 'card-list-item-empty',
}

export const CARD_LIST_ITEM_STATUS = {
  APPROVED: 'Approved',
  PENDING: 'Pending',
  REJECTED: 'Rejected',
  CANCELED: 'Canceled',
}
